import { ApiService } from 'src/services/core';
import HbsUcretTarifetanim from 'src/models/Settings/Generals/HbsUcretTarifeTanimDTO';

class HbsUcretTarifetanimService extends ApiService<HbsUcretTarifetanim> {
  constructor() {
    super('HbsUcretTarifetanimDTO');
  }
}
export default new HbsUcretTarifetanimService();
